export default {"src":"/_next/static/media/handcuffs_64.cf927fa9.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};